import { SiteIdOverrideConfig } from "stores/wizard/config";

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
export const siteId4_en_CA: SiteIdOverrideConfig = {
  package: {
    navigation: {
      tabTitleToken: "wizard.package.tab.title.variant.1.label",
    },
  },
};
